export const numSpaces = num => {
  if (num.toString().length <= 3) return num

  const split = num.toString().split('.')
  const str = split[0]
  let result = ''

  for (let i = str.length - 1; i >= 0; i--) {
    result = `${ str[i] }${ result }`
    if ((str.length - i) % 3 === 0) result = ` ${ result }`
  }

  if (split[1]) result = `${ result.trim() }.${ split[1] }`
  return result
}

export const clearSuffix = (str, suff) => {
  const split = str.split(' ')
  return split.pop() === suff ? split.join(' ') : str
}

export const strNumOnly = text => {
  const res = new RegExp(/(\d+)/).exec(text)
  return res ? res[0] : ''
}

export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

export const twitterLink = tokenID => `https://twitter.com/intent/tweet?text=Cool%20Cat%20%23${ tokenID }%C2%A0%0A%E6%88%91%E7%9A%84%E6%96%B0%23NFT%E4%BB%8E%23CoolCatsTron%0A%E7%9C%8B%E7%9C%8B%EF%BC%81%20%F0%9F%98%BB%20https%3A%2F%2Fcoolcatstron.com%2Fgallery%2F${ tokenID }`

export const telegramLink = tokenID => `https://t.me/share/url?url=https://coolcatstron.com/gallery/${ tokenID }&text=Cool%20Cat%20%23${ tokenID }%C2%A0%0A%E5%88%9A%E5%88%9A%E5%BE%97%E5%88%B0%E4%BA%86%E6%88%91%E7%9A%84%E6%96%B0%23NFT%20by%20%23CoolCatsTron%E3%80%82%20%E7%9C%8B%E7%9C%8B%EF%BC%81`